import type { Phrase } from '../types';
import type { bookingEn } from './booking.en';

export const bookingMl: Partial<Record<keyof typeof bookingEn, Phrase>> = {
  // page chrome
  bkfTitle: 'ബുക്കിംഗ് അഭ്യർത്ഥന',
  bkfSubtitle: 'കുറച്ച് ചെറിയ ഘട്ടങ്ങൾ. ഇപ്പോൾ ഒന്നും അടയ്ക്കേണ്ടതില്ല.',
  bkfBackToVenue: 'വേദിയിലേക്ക് മടങ്ങുക',
  bkfDraftRestored: 'നിങ്ങൾ മുമ്പ് നൽകിയ വിവരങ്ങൾ സൂക്ഷിച്ചിട്ടുണ്ട്.',
  bkfStartOver: 'വീണ്ടും തുടങ്ങുക',

  // progress
  bkfProgress: 'ബുക്കിംഗ് പുരോഗതി',
  bkfStepOf: 'ഘട്ടം {n} / {total}: {name}',
  bkfStepDone: 'പൂർത്തിയായി',
  bkfStepEvent: 'പരിപാടി',
  bkfStepDate: 'തീയതിയും സമയവും',
  bkfStepGuests: 'അതിഥികൾ',
  bkfStepExtras: 'ആവശ്യങ്ങൾ',
  bkfStepReview: 'പരിശോധന',
  bkfStepSend: 'അയയ്ക്കുക',
  bkfNext: 'തുടരുക',
  bkfBack: 'പിന്നോട്ട്',

  // step 1
  bkfEventTitle: 'എന്താണ് നിങ്ങൾ പ്ലാൻ ചെയ്യുന്നത്?',
  bkfEventBody: 'പരിപാടിയുടെ തരം തിരഞ്ഞെടുക്കുക. നിങ്ങളുടെ അഭ്യർത്ഥനയോടൊപ്പം വേദി ഇത് കാണും.',
  bkfSuggested: 'നിർദ്ദേശിച്ചത്',
  bkfSuggestionNote: '"നിർദ്ദേശിച്ചത്" എന്ന് അടയാളപ്പെടുത്തിയവ ഇത്തരം വേദികൾ സാധാരണ ബുക്ക് ചെയ്യപ്പെടുന്ന പരിപാടികളാണ്. ഏത് പരിപാടിയും തിരഞ്ഞെടുക്കാം.',
  bkfEventRequired: 'തുടരാൻ പരിപാടിയുടെ തരം തിരഞ്ഞെടുക്കുക.',

  // step 2
  bkfDateTitle: 'വേദി എപ്പോഴാണ് വേണ്ടത്?',
  bkfDateBody: 'ഒരു ദിവസം തിരഞ്ഞെടുക്കുക, തുടർന്ന് സെഷൻ, മണിക്കൂറുകൾ അല്ലെങ്കിൽ പല ദിവസങ്ങൾ.',
  bkfYourSlot: 'നിങ്ങൾ തിരഞ്ഞെടുത്ത സമയം',
  bkfSlotPrefilled: 'വേദി പേജിൽ തിരഞ്ഞെടുത്തത്. മാറ്റാൻ താഴെ മറ്റൊരു സമയം തിരഞ്ഞെടുക്കുക.',
  bkfSlotRequired: 'തുടരാൻ തീയതിയും സമയവും തിരഞ്ഞെടുക്കുക.',
  bkfQuoteLoading: 'നിരക്ക് കണക്കാക്കുന്നു…',
  bkfQuoteProblem: 'ഈ സമയം ബുക്ക് ചെയ്യാനാവില്ല',

  // step 3
  bkfGuestsTitle: 'എത്ര അതിഥികൾ?',
  bkfGuestsBody: 'ഏകദേശ എണ്ണം മതി. ഇരിപ്പിടം ഒരുക്കാൻ ഇത് വേദിയെ സഹായിക്കും.',
  bkfGuestsLabel: 'പ്രതീക്ഷിക്കുന്ന അതിഥികൾ',
  bkfSeats: '{count} ഇരിപ്പിടം',
  bkfFloatingCap: '+ {count} നിൽക്കുന്നവർ',
  bkfMaxCap: 'ആകെ {count} അതിഥികൾ വരെ',
  bkfGuestsRequired: 'അതിഥികളുടെ എണ്ണം നൽകുക (1 അല്ലെങ്കിൽ കൂടുതൽ).',
  bkfGuestsWhole: 'ഒരു പൂർണ്ണ സംഖ്യ നൽകുക.',
  bkfGuestsTooMany: 'ഈ വേദിയിൽ പരമാവധി {count} അതിഥികൾക്കാണ് സ്ഥലം.',
  bkfGuestsStanding: 'ഇരിപ്പിട ശേഷിയേക്കാൾ കൂടുതൽ — ചില അതിഥികൾ നിൽക്കേണ്ടി വരും.',
  bkfLess: 'അതിഥികളെ കുറയ്ക്കുക',
  bkfMore: 'അതിഥികളെ കൂട്ടുക',

  // step 4
  bkfExtrasTitle: 'വേദി അറിയേണ്ട മറ്റെന്തെങ്കിലും?',
  bkfExtrasBody: 'ഇവ വേദിയോടുള്ള അഭ്യർത്ഥനകളാണ്, ഉറപ്പുകളല്ല. എന്തൊക്കെ ഒരുക്കാനാകുമെന്ന് വേദി അറിയിക്കും.',
  bkfExtrasGroup: 'വേദിയോടുള്ള അഭ്യർത്ഥനകൾ',
  bkfReqStage: 'സ്റ്റേജ് അലങ്കാരം',
  bkfReqSound: 'ശബ്ദവും വെളിച്ചവും',
  bkfReqCatering: 'കാറ്ററിംഗ്',
  bkfReqSeating: 'അധിക ഇരിപ്പിടം',
  bkfReqParking: 'അതിഥികൾക്ക് പാർക്കിംഗ്',
  bkfReqAc: 'മുഴുവൻ എസി',
  bkfReqPhoto: 'ഫോട്ടോഗ്രഫിക്ക് സ്ഥലം',
  bkfNotesLabel: 'വേദിക്കുള്ള കുറിപ്പുകൾ',
  bkfOptional: 'ഐച്ഛികം',
  bkfNotesPlaceholder: 'ഉദാ: പരിപാടിയുടെ സമയക്രമം, കാറുകളുടെ എണ്ണം, വേദി ഒരുക്കേണ്ട കാര്യങ്ങൾ',
  bkfNotesCount: '{count} / {max}',
  bkfNotesTooLong: 'കുറിപ്പുകളും അഭ്യർത്ഥനകളും ചേർത്ത് {max} അക്ഷരങ്ങളിൽ താഴെയാകണം. കുറിപ്പ് ചുരുക്കുക.',

  // step 5
  bkfReviewTitle: 'നിങ്ങളുടെ അഭ്യർത്ഥന പരിശോധിക്കുക',
  bkfReviewBody: 'അയയ്ക്കും മുൻപ് എന്തെങ്കിലും മാറ്റാൻ ആ വരിയിലെ "മാറ്റുക" തൊടുക.',
  bkfEdit: 'മാറ്റുക',
  bkfEditLabel: '{section} മാറ്റുക',
  bkfEvent: 'പരിപാടി',
  bkfWhen: 'എപ്പോൾ',
  bkfGuests: 'അതിഥികൾ',
  bkfGuestCount: { one: '{count} അതിഥി', other: '{count} അതിഥികൾ' },
  bkfRequests: 'അഭ്യർത്ഥനകൾ',
  bkfNotes: 'കുറിപ്പുകൾ',
  bkfNone: 'ഒന്നുമില്ല',
  bkfEstimate: 'ഏകദേശ ആകെ തുക',
  bkfNoPayNow: 'ഇപ്പോൾ പണമടയ്ക്കേണ്ട. വേദി നിങ്ങളുടെ അഭ്യർത്ഥന സ്ഥിരീകരിച്ച ശേഷം നേരിട്ട് അവർക്ക് പണം നൽകുക.',
  bkfTermsTitle: 'വേദിയുടെ നിബന്ധനകൾ',
  bkfTermBuffer: { one: 'ഓരോ പരിപാടിക്കും മുമ്പും ശേഷവും വൃത്തിയാക്കാൻ വേദി {count} മിനിറ്റ് ഒഴിച്ചിടും.', other: 'ഓരോ പരിപാടിക്കും മുമ്പും ശേഷവും വൃത്തിയാക്കാൻ വേദി {count} മിനിറ്റ് ഒഴിച്ചിടും.' },
  bkfTermPeak: 'ശനി, ഞായർ ദിവസങ്ങളിൽ സാധാരണ ദിവസങ്ങളേക്കാൾ {percent}% കൂടുതൽ. ഏകദേശ തുകയിൽ ഇത് ഉൾപ്പെട്ടിട്ടുണ്ട്.',
  bkfTermPayAtVenue: 'അഡ്വാൻസ് വേണ്ട. വേദി സ്ഥിരീകരിച്ച ശേഷം മുഴുവൻ തുകയും വേദിയിൽ നൽകിയാൽ മതി.',

  // step 6
  bkfSendTitle: 'അഭ്യർത്ഥന അയയ്ക്കുക',
  bkfSendBody: 'അയച്ചാലുടൻ {venue}-ന് നിങ്ങളുടെ അഭ്യർത്ഥന ലഭിക്കും. തുടർന്ന് നടക്കുന്നത്:',
  bkfAck: 'ഇതൊരു അഭ്യർത്ഥനയാണെന്ന് എനിക്ക് മനസ്സിലായി: വേദി ഇത് സ്ഥിരീകരിക്കും, ഞാൻ നേരിട്ട് വേദിക്ക് പണം നൽകും.',
  bkfAckRequired: 'മനസ്സിലായെന്ന് സ്ഥിരീകരിക്കാൻ ബോക്സിൽ ടിക്ക് ചെയ്യുക.',
  bkfSend: 'അഭ്യർത്ഥന അയയ്ക്കുക',
  bkfSending: 'അയയ്ക്കുന്നു…',

  // result
  bkfDoneTitle: 'നിങ്ങളുടെ അഭ്യർത്ഥന വേദിക്ക് ലഭിച്ചു',
  bkfDoneBody: 'അഭ്യർത്ഥന #{id} {venue}-ന് അയച്ചു.',
  bkfDoneDuplicate: 'ഈ സമയത്തിനായി നിങ്ങൾ നേരത്തെ അഭ്യർത്ഥിച്ചിരുന്നു. ഇത് അതേ അഭ്യർത്ഥന #{id} ആണ്; പുതിയതൊന്നും അയച്ചിട്ടില്ല.',
  bkfMoreVenues: 'കൂടുതൽ വേദികൾ കാണുക',
  bkfConflictTitle: 'ആ സമയം ഇപ്പോൾ ലഭ്യമല്ല',
  bkfErrorTitle: 'അഭ്യർത്ഥന അയയ്ക്കാനായില്ല',
  bkfPickAnother: 'മറ്റൊരു സമയം തിരഞ്ഞെടുക്കുക',
  bkfTryAgain: 'വീണ്ടും ശ്രമിക്കുക',

  // summary card
  bkfSummary: 'നിങ്ങളുടെ ബുക്കിംഗ്',
  bkfNoSlot: 'സമയം ഇതുവരെ തിരഞ്ഞെടുത്തിട്ടില്ല',

  // manager views
  bkfNotesFromGuest: 'കുറിപ്പുകൾ',

  // slot picker
  bkfByHalfDay: 'അര ദിവസം',
  bkfRatePerHour: 'മണിക്കൂറിന് {price}.',
  bkfRatePerHalfDay: 'അര ദിവസത്തിന് {price}.',
  bkfRatePerDay: 'ദിവസത്തിന് {price}.',
  bkfRateSessionHalf: 'ഓരോ സെഷനും {price}',
  bkfRateSessionHour: 'സെഷനുകൾക്ക് മണിക്കൂറിന് {price}',
  bkfRateFullDay: 'മുഴുവൻ ദിവസം {price}',
  bkfRateWeekendNote: 'ശനി, ഞായർ ദിവസങ്ങളിൽ {percent}% കൂടുതൽ.',
  bkfNoPricesTitle: 'ഈ വേദി ഇതുവരെ നിരക്കുകൾ നൽകിയിട്ടില്ല',
  bkfNoPricesBody: 'അതുവരെ ഓൺലൈനായി ബുക്ക് ചെയ്യാനാകില്ല. തീയതിക്കായി വേദിയെ വിളിക്കുകയോ സന്ദേശം അയയ്ക്കുകയോ ചെയ്യുക.',
  bkfDaysTooMany: 'ഒരു ബുക്കിംഗിൽ പരമാവധി {max} ദിവസം.',
  bkfDaysCrossTaken: 'ആ ദിവസങ്ങളിൽ ചിലത് ലഭ്യമല്ല. ചാരനിറത്തിലുള്ള ദിവസങ്ങൾ ഇല്ലാത്ത ഒരു കാലയളവ് തിരഞ്ഞെടുക്കുക.',
  bkfDaysPickFirst: 'പരിപാടിയുടെ ആദ്യ ദിവസം തൊടുക.',
  bkfDaysPickLast: 'ഇനി അവസാന ദിവസം തൊടുക (പരമാവധി {max} ദിവസം). ഒരു ദിവസം മാത്രമെങ്കിൽ അതേ ദിവസം വീണ്ടും തൊടുക.',
  bkfDaysSingle: 'ഒരു മുഴുവൻ ദിവസം. നീട്ടാൻ മറ്റൊരു ദിവസം തൊടുക.',
  bkfBufferTip: 'വൃത്തിയാക്കാനുള്ള സമയം: ഓരോ ബുക്കിംഗിനും മുൻപും ശേഷവും വേദിക്ക് {count} മിനിറ്റ് വേണം.',
  bkfBufferExplain: '"വൃത്തിയാക്കൽ സമയം" എന്നാൽ ആ സമയം മറ്റൊരു ബുക്കിംഗിനോട് ചേർന്നാണ്. ഓരോ പരിപാടിക്കും മുൻപും ശേഷവും വൃത്തിയാക്കാനും ഒരുക്കാനും വേദി {count} മിനിറ്റ് ഒഴിച്ചിടുന്നു, അതിനാൽ ആ സമയം ബുക്ക് ചെയ്യാനാകില്ല.',
  bkfDayInBuffer: 'ലഭ്യമല്ല. മറ്റൊരു ബുക്കിംഗിനോട് വളരെ അടുത്താണ് (വൃത്തിയാക്കൽ സമയം).',
  bkfHalfDayHeading: 'അര ദിവസം തിരഞ്ഞെടുക്കുക',
  bkfHalfFirst: 'ആദ്യ പകുതി',
  bkfHalfSecond: 'രണ്ടാം പകുതി',
  bkfPickHalfDay: 'നിരക്ക് കാണാൻ ദിവസത്തിന്റെ ആദ്യ പകുതിയോ രണ്ടാം പകുതിയോ തിരഞ്ഞെടുക്കുക.',

  bkfQuoteBreakdown: 'ആകെ തുക കണക്കാക്കിയത്',
  bkfLineHours: '{count} മണിക്കൂർ',
  bkfLineHalfDays: '{count} സെഷൻ',
  bkfLineDays: '{count} ദിവസം',
  bkfLineWeekend: 'വാരാന്ത്യ നിരക്ക്',

  bkfRefundPending: '{amount} തിരികെ ലഭിക്കാനുണ്ട് (വേദിയിൽ നിന്ന്)',
  bkfRefundDone: '{amount} തിരികെ നൽകി',
  bkfRefundNoneTier: 'പരിപാടിയോട് വളരെ അടുത്ത് റദ്ദാക്കിയതിനാൽ റീഫണ്ടില്ല',
  bkfCxlYouPaid: 'നിങ്ങൾ വേദിക്ക് നൽകിയത്',
  bkfCxlRefundAmount: 'നിങ്ങൾക്ക് തിരികെ ലഭിക്കുന്നത്',
  bkfCxlDone: 'ബുക്കിംഗ് റദ്ദാക്കി.',
  bkfMarkRefunded: 'റീഫണ്ട് നൽകി',
  bkfMarkRefundedTip: 'അതിഥിക്ക് തുക തിരികെ നൽകിയ ശേഷം ഇത് അമർത്തുക. അവർക്ക് അത് തിരികെ നൽകിയതായി കാണാം.',
  bkfRefundMarked: 'റീഫണ്ട് നൽകിയതായി രേഖപ്പെടുത്തി.',

  bkfAmountReceivedNow: 'ഇപ്പോൾ ലഭിച്ച തുക (₹)',
  bkfAmountReceivedHint: 'ആകെ തുകയുടെ ഏതു ഭാഗവും, അല്ലെങ്കിൽ മുഴുവൻ തുകയും നൽകുക. ബാക്കി കുടിശ്ശികയായി തുടരും.',
  bkfAmountOverTotal: 'ഇത് ആകെ തുകയേക്കാൾ ({amount}) കൂടുതലാണ്.',
  bkfBalanceAfter: 'ബാക്കി അടയ്ക്കാനുള്ളത്',
  bkfReceivedNow: 'ഇപ്പോൾ ലഭിച്ചത്',

  bkfApproveTip: 'ഈ ബുക്കിംഗ് സ്ഥിരീകരിക്കുക. ആ തീയതി മറ്റാർക്കും ലഭ്യമല്ലാതാകും, അതിഥിയെ അറിയിക്കും.',
  bkfRejectTip: 'ഈ അഭ്യർത്ഥന നിരസിക്കുക. വേദിക്ക് എടുക്കാനാകില്ലെന്ന് അതിഥിയെ അറിയിക്കും, തീയതി മറ്റുള്ളവർക്കായി തുറന്നിരിക്കും.',
  bkfWhenRange: '{from} മുതൽ {to} വരെ',
};
